<template>
  <div>
    <div class="search-form__wrapper" id="search-form">
      <input @paste="onPaste" type="text" :placeholder="placeholder" class="search" v-model="search" id="input"/>
      <button class="search-form__clear" type="button" @click.prevent="onClearClick"><img src="/img/cross.svg" width="16" height="16"></button>
      <button class="search-form__submit desktop" @click.prevent="onSearchClick(true)">
        <span class="form-button-description"> {{ btnText }}</span>
      </button>
    </div>
    <button class="search-form__submit mobile" @click.prevent="onSearchClick(true)">
      <span class="form-button-description"> {{ btnText }}</span>
    </button>
    <div class="error-valid" v-if="errorInput">
      <div class="error-valid__wrapper">
        <svg width="24" height="24" viewBox="0 0 24 24" stroke="black" xmlns="http://www.w3.org/2000/svg"
             class="error-valid__img">
          <g>
            <path d="M11.8896 4.94507V18.9451" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M4.88965 11.9451H18.8896" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
        </svg>
        <span class="error-valid__text">{{ errorInputText }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'

let getSignedRequestBody
try {
  getSignedRequestBody = await (
    await import(
      /* webpackChunkName: "link.chunk" */
      '../tools/getSignedRequestBody.js'
      )
  ).default
} catch (error) {
  getSignedRequestBody = async (url) => {
    return {sf_url: url}
  }
}

export default {
  name: 'SearchForm',
  props: {
    page: String,
    placeholder: String,
    btnText: String
  },
  data() {
    return {
      search: null,
      errorInput: false,
      errorInputText: '',
    }
  },
  methods: {
    async onSearchClick(isButtonClick) {
      this.$root.$emit('clear-results')
      const form = document.getElementById('search-form')
      this.errorInput = false
      form.classList.remove('search-form__wrapper_active')

      if (!this.search) {
        form.classList.add('search-form__wrapper_active')
        this.errorInput = true
        this.errorInputText = 'Paste the link to start searching'
        return
      }

      const isValid = this.checkValidLink(this.search)
      const fromSite = this.search.match(/tiktok/)

      this.$root.$emit('clear-error')

      if (isButtonClick) this.$root.$emit('search-clicked')

      this.$root.$emit('loader-state-change', true)
      if (isValid) {
        if (fromSite) {
          try {
            const reqBody = await getSignedRequestBody(
              this.search.trim()
            )
            const postResponse = await axios.post(
              `/api/convert`,
              new URLSearchParams(reqBody)
            )
            console.log('Response: ', postResponse)

            if (postResponse?.data?.success === false) {
              throw new Error(postResponse?.data?.message)
            }

            this.$root.$emit(
              'tt-result-received',
              postResponse.data
            )
          } catch (error) {
            if (error?.response?.status === 401) {
              const e = error.response.data
              this.$root.$emit('error-occured', e.error_message, 'Unauthorized')
            } else if (
              error?.message ===
              'Request failed with status code 400'
            ) {
              this.$root.$emit(
                'error-occured',
                `The download link not found.`
              )
            } else {
              this.$root.$emit(
                'error-occured',
                `Something went wrong, please try again.`
              )
            }
          }
        } else {
          this.$root.$emit(
            'error-occured',
            `Sorry, it seems that the link is not valid :( Please, try again.`
          )
        }
      } else {
        form.classList.add('search-form__wrapper_active')
        this.errorInput = true
        this.errorInputText =
          'Wrong link format. Paste correct link and try again'
        this.$root.$emit(
          'error-occured', null,
          `Wrong link format. Paste correct link and try again`
        )
      }

      this.$root.$emit('loader-state-change', false)
    },
    onClearClick(e) {
      this.search = null
      this.errorInput = false
      this.$root.$emit('clear-results')
      this.$root.$emit('clear-error')
      const form = document.getElementById('search-form')
      form.classList.remove('search-form__wrapper_active')
      const input = form.querySelector('.search') 
      input.value = '';
      input.focus();
    },
    onPaste() {
      window.setTimeout(() => {
        const isValid = this.checkValidLink(this.search)
        if (isValid) {
          this.$root.$emit('input-inserted', 'link')
          this.onSearchClick(false)
        }
      }, 10)
    },
    checkValidLink(searchQuery) {
      const ttUsernameMatchRegex = /(?:(?:http|https):\/\/)/im
      let trimmedQuery = searchQuery.trim()
      const ttUsernameMatch = ttUsernameMatchRegex.test(trimmedQuery)
      return ttUsernameMatch
    },
  },
}
</script>
